(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__qaQuickAddInit) return;
  window.__qaQuickAddInit = true;

  function closeAll(except) {
    document.querySelectorAll('#CollectionSection .qa-quickadd.is-open').forEach(function (el) {
      if (el !== except) {
        el.classList.remove('is-open');
        var t = el.querySelector('[data-quickadd-toggle]');
        var o = el.querySelector('[data-quickadd-options]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function openDrawer() {
    try {
      if (window.timber && timber.RightDrawer && typeof timber.RightDrawer.open === 'function') {
        timber.RightDrawer.init && timber.RightDrawer.init();
        timber.RightDrawer.open();
        return true;
      }
    } catch (e) {}
    return false;
  }

  function refreshThenOpen() {
    // Use the theme's own ajax cart refresh so #CartContainer is filled and the
    // loading spinner is cleared, THEN open the drawer.
    var refreshed = false;
    try {
      if (window.theme && theme.ajaxCart && typeof theme.ajaxCart.update === 'function') {
        theme.ajaxCart.update(function () {
          openDrawer();
        });
        refreshed = true;
      }
    } catch (e) {}

    if (!refreshed) {
      // Last-resort fallback: fetch cart, fire the theme's update callback if present, then open.
      try {
        if (window.ShopifyAPI && typeof ShopifyAPI.getCart === 'function') {
          ShopifyAPI.getCart(function () {
            openDrawer();
          });
          return;
        }
      } catch (e2) {}
      openDrawer();
    }
  }

  function addVariant(card, variantId, btn) {
    var idInput = card.querySelector('[data-quickadd-id]');
    if (!idInput) return;
    idInput.value = variantId;

    if (btn) { btn.setAttribute('disabled', 'disabled'); }

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');

    fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add.js'), {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status && data.status !== 200) {
          // adding failed (e.g. sold out) — just re-enable and stop
          if (btn) { btn.removeAttribute('disabled'); }
          return;
        }
        refreshThenOpen();
      })
      .catch(function () {
        if (btn) { btn.removeAttribute('disabled'); }
      });
  }

  function showSizeStep(card, color) {
    if (!card) return;
    var colors = card.querySelector('[data-quickadd-colors]');
    if (colors) colors.setAttribute('hidden', '');
    card.querySelectorAll('[data-quickadd-sizes]').forEach(function (panel) {
      if (panel.getAttribute('data-quickadd-sizes') === color) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  function showColorStep(card) {
    if (!card) return;
    var colors = card.querySelector('[data-quickadd-colors]');
    if (colors) colors.removeAttribute('hidden');
    card.querySelectorAll('[data-quickadd-sizes]').forEach(function (panel) {
      panel.setAttribute('hidden', '');
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('#CollectionSection [data-quickadd-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      var card = toggle.closest('[data-quickadd]');
      var isOpen = card.classList.contains('is-open');
      closeAll(card);
      if (isOpen) {
        card.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        card.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    // Two-step: click a color -> show that color's sizes
    var colorBtn = e.target.closest('#CollectionSection [data-quickadd-color]');
    if (colorBtn) {
      e.preventDefault();
      e.stopPropagation();
      var cardC = colorBtn.closest('[data-quickadd]');
      var color = colorBtn.getAttribute('data-quickadd-color');
      showSizeStep(cardC, color);
      return;
    }

    // Two-step: back arrow -> return to colors
    var backBtn = e.target.closest('#CollectionSection [data-quickadd-back]');
    if (backBtn) {
      e.preventDefault();
      e.stopPropagation();
      var cardB = backBtn.closest('[data-quickadd]');
      showColorStep(cardB);
      return;
    }

    var size = e.target.closest('#CollectionSection [data-quickadd-variant]');
    if (size) {
      e.preventDefault();
      e.stopPropagation();
      var card2 = size.closest('[data-quickadd]');
      addVariant(card2, size.getAttribute('data-quickadd-variant'), size);
      card2.classList.remove('is-open');
      card2.classList.remove('is-hovering');
      // Force the full-width bar to slide down cleanly even though the pointer is still over it
      card2.classList.add('qa-closing');
      showColorStep(card2);
      var clearClosing = function () {
        card2.classList.remove('qa-closing');
        card2.removeEventListener('mouseleave', clearClosing);
      };
      card2.addEventListener('mouseleave', clearClosing);
      return;
    }

    // Click outside any quick-add closes open panels
    if (!e.target.closest('#CollectionSection .qa-quickadd')) {
      closeAll(null);
    }
  });

  // On desktop, reset to the color step whenever the hover bar leaves
  // Desktop hover management: toggle .is-hovering when pointer is over the + or the bar
  document.addEventListener('mouseover', function (e) {
    var qa = e.target.closest && e.target.closest('#CollectionSection .qa-quickadd');
    if (!qa) return;
    // Only react to the + toggle or the options bar, not the whole card
    if (e.target.closest('[data-quickadd-toggle]') || e.target.closest('.qa-options')) {
      if (!qa.classList.contains('qa-closing')) qa.classList.add('is-hovering');
    }
  });

  document.addEventListener('mouseout', function (e) {
    var qa = e.target.closest && e.target.closest('#CollectionSection .qa-quickadd');
    if (!qa) return;
    // When leaving the quick-add entirely, close it and reset to colors
    if (!qa.contains(e.relatedTarget)) {
      qa.classList.remove('is-hovering');
      var colorCard = qa.hasAttribute('data-quickadd-color-index') ? qa : null;
      if (colorCard) showColorStep(colorCard);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStickyAtc(root) {
    var sectionId = root.getAttribute('data-sticky-section');
    var bar = root;
    var button = bar.querySelector('[data-sticky-atc-button]');
    var sizeLabel = bar.querySelector('[data-sticky-atc-size]');
    var btnText = bar.querySelector('[data-sticky-atc-button-text]');
    if (!button) return;

    var container = document.getElementById('section-' + sectionId) ||
                    document.querySelector('[data-section-id="' + sectionId + '"]');
    if (!container) container = document;

    // Move the bar to <body> so no ancestor stacking context (e.g. footer) can cover it
    if (bar.parentNode !== document.body) {
      document.body.appendChild(bar);
    }

    // Load product JSON for variant resolution
    var product = null;
    try {
      var jsonEl = document.getElementById('ProductJson-' + sectionId);
      if (jsonEl) product = JSON.parse(jsonEl.textContent);
    } catch (e) {}

    var mainAtc = container.querySelector('#AddToCart--' + sectionId) ||
                  container.querySelector('.btn--add-to-cart');

    function getSelectedOptions() {
      var opts = [];
      var selectors = container.querySelectorAll('.js-single-option-selector');
      selectors.forEach(function (el) {
        if (el.type === 'radio') {
          if (el.checked) {
            var idx = parseInt((el.getAttribute('data-index') || 'option1').replace('option', ''), 10) - 1;
            opts[idx] = el.value;
          }
        } else {
          var idx2 = parseInt((el.getAttribute('data-index') || 'option1').replace('option', ''), 10) - 1;
          opts[idx2] = el.value;
        }
      });
      return opts;
    }

    function findVariant(opts) {
      if (!product || !product.variants) return null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] != null && v.options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function updateSticky() {
      var opts = getSelectedOptions();
      var v = findVariant(opts);
      if (!v && product && product.variants && product.variants.length) {
        v = product.variants[0];
      }
      if (!v) return;

      button.setAttribute('data-sticky-atc-variant', v.id);

      if (sizeLabel && product && !product.has_only_default_variant) {
        sizeLabel.textContent = v.title;
      }

      if (v.available) {
        button.removeAttribute('disabled');
        if (btnText) btnText.textContent = (window.theme && theme.strings && theme.strings.addToCart) || 'Add to cart';
      } else {
        button.setAttribute('disabled', 'disabled');
        if (btnText) btnText.textContent = (window.theme && theme.strings && theme.strings.soldOut) || 'Sold out';
      }
    }

    // Keep in sync with option changes
    container.addEventListener('change', function (e) {
      if (e.target.closest('.js-single-option-selector') || e.target.classList.contains('js-single-option-selector')) {
        // let theme update first, then read
        setTimeout(updateSticky, 0);
      }
    });
    container.addEventListener('click', function (e) {
      if (e.target.closest('.single-option-radio label')) {
        setTimeout(updateSticky, 0);
      }
    });

    // Show/hide the sticky bar: only when the ATC has been scrolled PAST (is above the viewport)
    if (mainAtc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var r = entry.boundingClientRect;
          // ATC is above the viewport (user scrolled past it downward)
          var scrolledPast = !entry.isIntersecting && r.bottom <= (entry.rootBounds ? entry.rootBounds.top : 0);
          if (scrolledPast) {
            bar.classList.add('is-visible');
            bar.setAttribute('aria-hidden', 'false');
          } else {
            bar.classList.remove('is-visible');
            bar.setAttribute('aria-hidden', 'true');
          }
        });
      }, { root: null, threshold: 0, rootMargin: '0px 0px -20px 0px' });
      io.observe(mainAtc);
    }

    // Cart add (reuse the theme's ajax cart + drawer flow)
    function openDrawer() {
      try {
        if (window.timber && timber.RightDrawer && typeof timber.RightDrawer.open === 'function') {
          timber.RightDrawer.init && timber.RightDrawer.init();
          timber.RightDrawer.open();
          return;
        }
      } catch (e) {}
    }
    function refreshThenOpen() {
      try {
        if (window.theme && theme.ajaxCart && typeof theme.ajaxCart.update === 'function') {
          theme.ajaxCart.update(function () { openDrawer(); });
          return;
        }
      } catch (e) {}
      try {
        if (window.ShopifyAPI && typeof ShopifyAPI.getCart === 'function') {
          ShopifyAPI.getCart(function () { openDrawer(); });
          return;
        }
      } catch (e2) {}
      openDrawer();
    }

    button.addEventListener('click', function () {
      var variantId = button.getAttribute('data-sticky-atc-variant');
      if (!variantId || button.hasAttribute('disabled')) return;
      button.setAttribute('disabled', 'disabled');

      var body = new FormData();
      body.append('id', variantId);
      body.append('quantity', '1');

      fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add.js'), {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          button.removeAttribute('disabled');
          if (data && data.status && data.status !== 200) return;
          refreshThenOpen();
        })
        .catch(function () { button.removeAttribute('disabled'); });
    });

    updateSticky();
  }

  function boot() {
    document.querySelectorAll('[data-sticky-atc]').forEach(function (el) {
      if (el.__stickyInit) return;
      el.__stickyInit = true;
      initStickyAtc(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
